import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import { AuthService } from './auth.service';
import { NewLinePipe } from "./pipes";

export const firebaseConfig = {
  apiKey: "AIzaSyDsF3tGzZfL1VbZ8C5og9kKVyiSd6qZNuM",
  authDomain: "how-tos-ceea6.firebaseapp.com",
  databaseURL: "https://how-tos-ceea6.firebaseio.com",
  projectId: "how-tos-ceea6",
  storageBucket: "how-tos-ceea6.appspot.com",
  messagingSenderId: "541289839731"
}

@NgModule({
  declarations: [
    AppComponent,
    NewLinePipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/src/app/app.module.ts